<template lang="pug">
.keyShortcuts(v-if="open")
  .overlay
  .inside(@click="toggleOpen")
    h1 {{$t('keyshortcuts.title')}}
    p {{$t('keyshortcuts.subtitle')}}
    table
      tr(v-for="(label, key) in keys", :key="key")
        td 
          template(v-for='(k, i) in keyParts(key)')
            .key {{withMetaKey(k)}}
            span.and(v-if='i < keyParts(key).length - 1') +
        td {{$t('keyshortcuts.' + label + '.' + clean(key))}}
</template>
<script>
import MousetrapManager from '@/components/shared/mousetrapManager'
import eventsBus from '@/components/shared/EventsBus'

export default {
  mounted () {
    MousetrapManager.bind('command+k', () => {
      this.toggleOpen()
    }, 'KeyShortcuts')
    eventsBus.$on(eventsBus.SHOW_KEYSHORTCUTS, () => {
      this.toggleOpen()
    })
  },
  destroyed () {
    MousetrapManager.unbindLabel('KeyShortcuts')
  },
  data () {
    return {
      open: false,
      keys: {}
    }
  },
  methods: {
    toggleOpen () {
      this.open = !this.open
      if (this.open) {
        this.keys = MousetrapManager.currentKeys()
      }
    },
    clean (key) {
      return key
      .replace(/\+/, '_plus_')
      .replace(/\?/, '_interro_')
      .replace(/\//, '_backslash_')
    },
    keyParts (key) {
      return key.split('+')
    },
    withMetaKey (key) {
      if (key === 'command') {
        return '⌘'
      }
      if (key === 'shift') {
        return '^'
      }
      return key
    }
  }
}
</script>
<style scoped>
.overlay {

}
</style>



// WEBPACK FOOTER //
// keyshortcuts.vue?519d5250